module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Page-Module Master")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(_vm.$sessionsStorage.get('designation') == 'Admin' && _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('b-nav-form', [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addEditCardFunc()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getAllPageModuleMasterList('Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.addEditCard) ? _c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', {
    staticClass: "justify-content-left"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.PageModuleMaster.pagemodule_name) + " Page-Module Details")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Module Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllModuleList'],
      "option-value": "module_id",
      "option-text": "module_name",
      "placeholder": "Select Module Name"
    },
    on: {
      "input": function($event) {
        _vm.SubModuleDataGet(_vm.PageModuleMaster.fk_module_id)
      }
    },
    model: {
      value: (_vm.PageModuleMaster.fk_module_id),
      callback: function($$v) {
        _vm.$set(_vm.PageModuleMaster, "fk_module_id", $$v)
      },
      expression: "PageModuleMaster.fk_module_id"
    }
  }), _vm._v(" "), (!_vm.PageModuleMaster.fk_module_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.fk_module_id))]) : _vm._e()], 1), _vm._v(" "), (_vm.PageModuleMaster.fk_module_id != '') ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("SubModule Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllSubModuleList'],
      "id": "submodule_id",
      "option-value": "submodule_id",
      "option-text": "submodule_name",
      "placeholder": "Select Sub-Module Name"
    },
    model: {
      value: (_vm.PageModuleMaster.fk_submodule_id),
      callback: function($$v) {
        _vm.$set(_vm.PageModuleMaster, "fk_submodule_id", $$v)
      },
      expression: "PageModuleMaster.fk_submodule_id"
    }
  }), _vm._v(" "), (!_vm.PageModuleMaster.fk_submodule_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.fk_submodule_id))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Page-Module Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "pagemodule_name",
      "name": "pagemodule_name",
      "placeholder": "Page Module Name"
    },
    on: {
      "input": function($event) {
        _vm.submoduleUrl(_vm.PageModuleMaster.pagemodule_name)
      }
    },
    model: {
      value: (_vm.PageModuleMaster.pagemodule_name),
      callback: function($$v) {
        _vm.$set(_vm.PageModuleMaster, "pagemodule_name", $$v)
      },
      expression: "PageModuleMaster.pagemodule_name"
    }
  }), _vm._v(" "), (!_vm.PageModuleMaster.pagemodule_name) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.pagemodule_name) + " ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Page-Module URL "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "pagemodule_url",
      "name": "pagemodule_url",
      "placeholder": "Page-Module URL"
    },
    model: {
      value: (_vm.PageModuleMaster.pagemodule_url),
      callback: function($$v) {
        _vm.$set(_vm.PageModuleMaster, "pagemodule_url", $$v)
      },
      expression: "PageModuleMaster.pagemodule_url"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "id": 'approval' + _vm.PageModuleMaster.is_pagemodule_active,
      "name": "approval",
      "value": _vm.PageModuleMaster.is_pagemodule_active == 1 ? true : false
    },
    on: {
      "change": function($event) {
        _vm.activatepagemoduleMaster()
      }
    }
  }, [_c('h6', [_c('b-badge', {
    attrs: {
      "variant": _vm.PageModuleMaster.is_pagemodule_active == 1 ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.PageModuleMaster.is_pagemodule_active == 1 ? "Active" : "In-Active"))])], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-bottom": "0.3rem"
    },
    attrs: {
      "variant": "success",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addPageModuleMaster
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.PageModuleMaster.pagemodule_id ? "Update" : "Save") + "\n                  ")])], 1), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Page Module Master"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.All_Page_Module_List_data,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "responsive": "",
      "primary-key": "pagemodule_id"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "pagemodule_id",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "module_name",
      fn: function(row5) {
        return [_c('span', [_c('b', [_vm._v("Module Name: ")]), _vm._v(_vm._s(row5.item.module_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Sub-Module Name: ")]), _vm._v(_vm._s(row5.item.submodule_name))])]
      }
    }, {
      key: "pagemodule_name",
      fn: function(row1) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.$sessionsStorage.get('designation') == 'Admin' && _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ? _vm.viewEdit(row1.item) : ''
            }
          }
        }, [_vm._v(_vm._s(row1.item.pagemodule_name))])]
      }
    }, {
      key: "pagemodule_url",
      fn: function(row11) {
        return [_c('span', [_vm._v(_vm._s((row11.item.pagemodule_url != '') ? row11.item.pagemodule_url : '--'))])]
      }
    }, {
      key: "is_pagemodule_active",
      fn: function(row22) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row22.item.pagemodule_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row22.item.pagemodule_id,
            "name": "approval",
            "value": row22.item.is_pagemodule_active == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateModuleUser(row22.item, 'Active')
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row22.item.is_pagemodule_active == 1 ? 'Active' : 'In-Active'))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row22.item.pagemodule_id
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row22.item.is_pagemodule_active == 1 ? 'Active' : 'In-Active'))])], 1)])]
      }
    }, {
      key: "is_pagemodule_delete",
      fn: function(row22) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row22.item.pagemodule_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row22.item.pagemodule_id,
            "name": "approval",
            "value": row22.item.is_pagemodule_delete == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateModuleUser(row22.item, 'Delete')
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row22.item.is_pagemodule_delete == 1 ? 'Delete' : 'Not Deleted'))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row22.item.pagemodule_id
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row22.item.is_pagemodule_delete == 1 ? 'Deleted' : 'Not Delete'))])], 1)])]
      }
    }, {
      key: "action",
      fn: function(row2) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editPageModuleMaster(row2.item)
            }
          }
        }, [_vm._v("Update")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c180095","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/masters/pagemoduleMaster.vue
// module id = 2487
// module chunks = 0